import { HttpService } from 'core/modules/network-service';
import { get } from 'lodash';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getVisibleItems, isVisible } from 'resolvers/getVisibleEntities';

/*************************************************************/

/**
 * @type {class}
 * @desc MemberInfoSettingShippingInfo defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { MemberInfoSettingShippingInfoService } from 'services/memberInfoSettingShippingInfo';
 *
 * // create service instance and send/cancel request
 * const memberInfoSettingShippingInfoService = new MemberInfoSettingShippingInfoService();
 * const result = await memberInfoSettingShippingInfoService.fetchData( '<user-id>' ); // fetch data
 * memberInfoSettingShippingInfoService.cancel(); // cancel an active request
 */
export class MemberInfoSettingShippingInfoService extends HttpService {

    // make request and fetch data
    async fetchComponentData( { url, data } ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            // extract data
            const component = get( response, 'body.component', {} );
            const visibility = get( response, 'body.component.visibility', {} );
            const modifyActions = get( response, 'body.component.structure.modifyActions', {} );
            const addActionShipping = get( response, 'body.component.structure.addActionShipping', {} );
            
            if( SERVICE_RESPONSE_STATUS.SUCCESS === get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ) ) {
                return {
                    status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                    data: {
                        options: get( response, 'body.component.data.options', {} ),
                        addresses: get( response, 'body.component.data.state.addresses', {} ),
                        addAction: isVisible( addActionShipping, visibility ) ? addActionShipping: {},
                        modifyActions: getVisibleItems( modifyActions, visibility ),
                        
                        // widgetConfig: {
                            changeConfirmation: get( component, 'structure.widgetConfig.changeConfirmation', {} ),
                            defaultDescription: isVisible( get( component, 'structure.widgetConfig.defaultDescription', {} ), visibility ) ? get( response, 'body.component.structure.widgetConfig.defaultDescription', {} ): {}
                        
                            // },
                    },
                };
            } else {
                return {
                    status: SERVICE_RESPONSE_STATUS.FAILURE,
                    data: get( response, 'body.component.data', {} )
                };
            }
            
        } catch( errResponse ) {
            return this._errorFormatter( errResponse );
        }
    }

   // make request and fetch data
   async setDefaultAddress( { url, data } ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data
            } );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: get( response, 'body.component.data.state', get( response, 'body.component.data', {} ) ),
            };

        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
            };
        }
    }

    // make request and fetch data
    async deleteSavedAddress( { url, data } ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data
            } );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: get( response, 'body.component.data.state', get( response, 'body.component.data', {} ) ),
            };

        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
            };
        }
    }

    // make request and inactivate
    async inactivateSavedAddress( { url, data } ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data
            } );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: get( response, 'body.component.data.state', get( response, 'body.component.data', {} ) ),
            };

        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
            };
        }
    }

    // make request and activate
    async activateSavedAddress( { url, data } ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data
            } );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: get( response, 'body.component.data.state', get( response, 'body.component.data', {} ) ),
            };

        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
            };
        }
    }


    // get the valid address
    async submitSelectedAddress( { url, data } ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data
            } );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: get( response, 'body.component.data.state', get( response, 'body.component.data', {} ) ),
                
                // data: {
                //     id: get( response, 'body.status.component.data.itemdIds', [] ),
                // }
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
    
    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
